import { createContext, useContext } from "react";

// Ruta base del módulo: "/visitors" en el panel principal, "/patrol/visitors" en la interfaz del vigilante
const VisitorBaseContext = createContext("/visitors");

export const VisitorBaseProvider = VisitorBaseContext.Provider;

export const useVisitorsBase = () => useContext(VisitorBaseContext);

// Adapta enlaces guardados como "/visitors/..." (p. ej. en notificaciones) a la ruta base actual
export const withVisitorsBase = (link, base) =>
  link && link.startsWith("/visitors") ? base + link.slice("/visitors".length) : link;
